<template>

  <BasicLayout>
    <div class="elevation-4">
      <v-toolbar flat="flat">
        <v-toolbar-title>Federations</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="addingFederation.dialog" max-width="500px">
          <v-icon slot="activator" title="Add a federation">mdi-plus</v-icon>
          <v-card>
            <v-card-title class="headline">Add a federation</v-card-title>
            <v-card-text>
              <v-text-field v-model="addingFederation.name" label="Name"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat="flat" @click.native="closeFederation">Cancel</v-btn>
              <v-btn color="primary" flat="flat" @click.native="saveFederation">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table hide-headers="hide-headers" hide-actions="hide-actions" :items="federationValues" :headers="columns">
        <template slot="items" slot-scope="props">
          <tr>
            <td>
              <FederationLink :id="props.item.id" :showID="true"></FederationLink>
            </td>
            <td class="federation-action">
              <v-icon class="mr-2" title="Delete" @click="deleteFederation(props.item)">mdi-delete</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar" color="error" :timeout="5000">{{ errorMessage }}</v-snackbar>
    </div>
  </BasicLayout>

</template>

<script>

import TableView from '@/components/common/TableView'
import TableLine from '@/components/common/TableLine'
import EditDeleteButtons from '@/components/common/EditDeleteButtons'
import BasicLayout from '@/layouts/BasicLayout'
import FederationLink from '@/components/links/Federation'
import { mapGetters } from 'vuex'

export default {
  name: 'FederationsPage',
  components: {
    TableView,
    TableLine,
    BasicLayout,
    EditDeleteButtons,
    FederationLink
  },
  data () {
    return {
      columns: [{
        text: 'Federation'
      }, {
        text: 'Action',
        width: '200px'
      }],
      originalFederation: null,
      addingFederation: this.defaultAddingFederation(),
      snackbar: null,
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters(['federationValues'])
  },
  methods: {
    defaultAddingFederation () {
      return {
        dialog: null,
        name: null
      }
    },

    closeFederation () {
      this.addingFederation = this.defaultAddingFederation()
    },

    saveFederation () {
      this.$store.dispatch('createFederation', {
        // TODO: set values
      })
        .then(federation => {
          this.router.push(`/federations/${federation.id}`)
        })
        .catch(err => {
          console.error(err)
          this.addingSport.dialog = false
          this.errorMessage = 'Cannot create the federation'
          this.snackbar = true
        })
    },

    deleteFederation (federation) {
      this.$store.dispatch('deleteFederation', federation.id)
        .catch(err => {
          console.error(err)
          this.errorMessage = 'Cannot delete the federation'
          this.snackbar = true
        })
    }
  },
  watch: {
    'addingFederation.dialog' (val) {
      if (!val) {
        this.closeFederation()
      }
    }
  },
  mounted () {
    this.$store.dispatch('getSports')
      .then(sports => {
        for (const sport of sports) {
          this.$store.dispatch('getSportFederations', sport.id)
            .catch(err => {
              console.error(err)
              this.errorMessage = 'Cannot get federations of ' + sport.name
              this.snackbar = true
            })
        }
      })
      .catch(err => {
        console.error(err)
        this.errorMessage = 'Cannot get sports list'
        this.snackbar = true
      })
  }
}

</script>

<style lang="scss" scoped>

@import '../../styles/main-colors.scss';

.box-header {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 50px;
  align-items: center;
}

.federation-action {
  width: 50px;
}

</style>



// WEBPACK FOOTER //
// src/pages/federation/Federations.vue